var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGtmCurveMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 624,
    height: 402,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.9375 0.75 1.9375 0.75 4 2 C4.75 4.125 4.75 4.125 5 6 C4.01 5.67 3.02 5.34 2 5 C0.8125 2.4375 0.8125 2.4375 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(563,256)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(375,345)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(334,345)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(406,344)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(303,344)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(282,343)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(220,338)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.7074998 1.28062485 3.37373596 2.61767557 5 4 C5 4.66 5 5.32 5 6 C3.0625 5.25 3.0625 5.25 1 4 C0.25 1.875 0.25 1.875 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(557,248)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.75 0.875 4.75 0.875 7 2 C7 2.66 7 3.32 7 4 C4.69 3.34 2.38 2.68 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(521,227)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(470,219)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(368,219)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(357,219)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(347,219)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(306,218)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(265,217)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(204,214)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(316,137)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(226,137)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(357,136)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(408,133)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C1.71034824 2.37562854 0.37310707 3.70766393 -1 5 C-1.66 5 -2.32 5 -3 5 C-1.125 1.125 -1.125 1.125 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(569,91)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C6.67 0.66 6.34 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(386,345)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6.33 0.66 6.66 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(365,345)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6.33 0.66 6.66 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(344,345)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C5.02 2 3.04 2 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(323,345)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C5.02 2 3.04 2 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(230,339)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-1.98 2.33 -3.96 2.66 -6 3 C-6.33 2.34 -6.66 1.68 -7 1 C-4.53721199 -0.231394 -2.7204945 -0.07159196 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(475,337)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-1.98 2.33 -3.96 2.66 -6 3 C-6.33 2.34 -6.66 1.68 -7 1 C-4 0 -4 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(485,335)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.598125 0.20625 1.19625 0.4125 1.8125 0.625 C-1.1875 2.625 -1.1875 2.625 -3.375 2.25 C-3.973125 2.04375 -4.57125 1.8375 -5.1875 1.625 C-2.1875 -0.375 -2.1875 -0.375 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(523.1875,324.375)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.598125 0.20625 1.19625 0.4125 1.8125 0.625 C-1.1875 2.625 -1.1875 2.625 -3.375 2.25 C-3.973125 2.04375 -4.57125 1.8375 -5.1875 1.625 C-2.1875 -0.375 -2.1875 -0.375 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(533.1875,320.375)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.1875 1.9375 1.1875 1.9375 0 4 C-0.99 4.33 -1.98 4.66 -3 5 C-1.125 1.125 -1.125 1.125 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(558,303)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 1.98 2 3.96 2 6 C1.01 6.495 1.01 6.495 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(571,275)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C2.625 4.0625 2.625 4.0625 3 7 C2.34 7 1.68 7 1 7 C0.67 4.69 0.34 2.38 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(569,265)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6.33 0.66 6.66 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(491,219)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C6.67 0.66 6.34 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(481,219)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6.33 0.66 6.66 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(460,219)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6.33 0.66 6.66 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(419,219)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C3.69 2 1.38 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(399,219)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C3.69 2 1.38 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(389,219)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C3.69 2 1.38 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(379,219)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C6.67 0.66 6.34 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(337,219)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C6.67 0.66 6.34 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(296,218)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6.33 0.66 6.66 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(224,215)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0.66 4.62 1.32 7 2 C7 2.66 7 3.32 7 4 C2.25 3.125 2.25 3.125 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(72,194)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.66 1.98 3.32 3.96 4 6 C3.01 5.67 2.02 5.34 1 5 C0.67 3.35 0.34 1.7 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(57,182)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C0.35 3.32 -1.3 4.64 -3 6 C-2.42655063 3.13275314 -2.1385485 2.1385485 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(62,173)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C0.1875 3.0625 0.1875 3.0625 -2 4 C-2.99 3.67 -3.98 3.34 -5 3 C-3.35 2.01 -1.7 1.02 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(80,163)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-2.31 2.33 -4.62 2.66 -7 3 C-5.40442685 -0.19114631 -3.35905282 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(101,157)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C3.69 2 1.38 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(196,139)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C5.02 2 3.04 2 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(326,137)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C6.67 0.66 6.34 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(306,137)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C5.02 2 3.04 2 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(285,137)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6.33 0.66 6.66 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(265,136)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C6.67 0.66 6.34 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(398,134)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C6.67 0.66 6.34 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(429,131)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-2.31 2.33 -4.62 2.66 -7 3 C-7 2.34 -7 1.68 -7 1 C-4.50935112 0.31292445 -2.62113708 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(456,128)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C3.69 2 1.38 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(460,127)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-2.31 2.33 -4.62 2.66 -7 3 C-7 2.34 -7 1.68 -7 1 C-4.50935112 0.31292445 -2.62113708 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(476,125)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-1.98 2.66 -3.96 3.32 -6 4 C-6.33 3.34 -6.66 2.68 -7 2 C-2.25 0 -2.25 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(536,110)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-1.8125 3.0625 -1.8125 3.0625 -4 4 C-4.99 3.67 -5.98 3.34 -7 3 C-2.25 0 -2.25 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(555,102)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.99 2.475 0.99 5 2 C5 2.99 5 3.98 5 5 C2.5 3.625 2.5 3.625 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(566,57)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0.33 4.62 0.66 7 1 C6.67 1.66 6.34 2.32 6 3 C3.03 2.505 3.03 2.505 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(528,42)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(355,345)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.78375 0.04125 1.5675 0.0825 2.375 0.125 C2.375 0.785 2.375 1.445 2.375 2.125 C0.065 2.125 -2.245 2.125 -4.625 2.125 C-2.625 0.125 -2.625 0.125 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(421.625,342.875)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-2.31 2.33 -4.62 2.66 -7 3 C-7 2.34 -7 1.68 -7 1 C-4.50935112 0.31292445 -2.62113708 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(434,342)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0.33 4.62 0.66 7 1 C7 1.33 7 1.66 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(272,342)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 1.67 2.38 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(251,341)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(241,340)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C5 2 5 2 2.375 2.125 C1.59125 2.08375 0.8075 2.0425 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(458,339)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-1.98 2.33 -3.96 2.66 -6 3 C-6.33 2.34 -6.66 1.68 -7 1 C-4 0 -4 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(495,333)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C-0.75 4 -0.75 4 -3 4 C-3 3.34 -3 2.68 -3 2 C-2.01 1.34 -1.02 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(541,315)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C0.84826645 2.46800047 -0.04783565 4.04783565 -2 6 C-2 3 -2 3 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(565,295)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.93423645 3.01031744 1.04449911 3.86650268 0 7 C-0.66 7 -1.32 7 -2 7 C-1.125 2.25 -1.125 2.25 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(570,285)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.875 1.75 4.875 1.75 6 4 C3.83125748 3.49396008 2.00032373 3.00016187 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(540,236)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0.66 3.96 1.32 6 2 C6 2.66 6 3.32 6 4 C4.02 3.34 2.04 2.68 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(531,231)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0.33 4.62 0.66 7 1 C7 1.66 7 2.32 7 3 C4.69 2.34 2.38 1.68 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(501,221)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(450,219)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(440,219)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(430,219)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(409,219)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5.33 0.66 5.66 1.32 6 2 C3.69 2 1.38 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(276,217)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(245,216)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0.33 4.62 0.66 7 1 C7 1.33 7 1.66 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(193,213)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 1.67 2.38 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(173,212)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0.33 4.62 0.66 7 1 C7 1.66 7 2.32 7 3 C4.69 2.67 2.38 2.34 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(132,207)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0.33 4.62 0.66 7 1 C7 1.33 7 1.66 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(122,206)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0.495 2.97 0.495 6 1 C6 1.66 6 2.32 6 3 C3.03 2.505 3.03 2.505 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(92,200)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0.66 3.96 1.32 6 2 C6 2.66 6 3.32 6 4 C4.02 3.34 2.04 2.68 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(63,190)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-1.98 2.66 -3.96 3.32 -6 4 C-6 3.34 -6 2.68 -6 2 C-2.25 0 -2.25 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(72,168)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-2.31 2.33 -4.62 2.66 -7 3 C-6.67 2.34 -6.34 1.68 -6 1 C-3.911361 0.32624548 -2.19636905 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(111,154)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C5 2 5 2 2.375 2.125 C1.59125 2.08375 0.8075 2.0425 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(165,143)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-2.31 2.33 -4.62 2.66 -7 3 C-7 2.34 -7 1.68 -7 1 C-4.50935112 0.31292445 -2.62113708 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(182,141)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.78375 0.04125 1.5675 0.0825 2.375 0.125 C2.375 0.785 2.375 1.445 2.375 2.125 C0.065 2.125 -2.245 2.125 -4.625 2.125 C-2.625 0.125 -2.625 0.125 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(189.625,139.875)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(296,137)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5.33 0.66 5.66 1.32 6 2 C3.69 2 1.38 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(348,136)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(247,136)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(378,135)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(419,132)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C5 2 5 2 2.375 2.125 C1.59125 2.08375 0.8075 2.0425 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(439,130)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.99 0 1.98 0 3 C-1.65 3.33 -3.3 3.66 -5 4 C-4.67 3.01 -4.34 2.02 -4 1 C-1.9375 0.3125 -1.9375 0.3125 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(525,113)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.99 0 1.98 0 3 C-1.65 3.33 -3.3 3.66 -5 4 C-5 3.34 -5 2.68 -5 2 C-3.35 1.34 -1.7 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(544,106)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C-0.75 4 -0.75 4 -3 4 C-3 3.34 -3 2.68 -3 2 C-2.01 1.34 -1.02 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(561,97)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C0.515 3.475 0.515 3.475 -1 6 C-1.66 5.34 -2.32 4.68 -3 4 C-2.01 2.68 -1.02 1.36 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(576,83)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 1.98 2 3.96 2 6 C1.34 6 0.68 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(578,73)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.66 0.99 3.32 1.98 4 3 C3.67 3.99 3.34 4.98 3 6 C0 2.25 0 2.25 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(574,64)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-1.98 2.33 -3.96 2.66 -6 3 C-6.33 2.34 -6.66 1.68 -7 1 C-4.50935112 0.31292445 -2.62113708 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(444,341)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-1.98 2.33 -3.96 2.66 -6 3 C-6 2.34 -6 1.68 -6 1 C-3.92446352 0.4465236 -2.15634036 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(505,330)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-1.98 2.33 -3.96 2.66 -6 3 C-4.60722783 0.21445565 -3.01148006 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(515,327)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.99 2.475 0.99 5 2 C4.67 2.99 4.34 3.98 4 5 C2 3.625 2 3.625 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(549,242)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 1.67 2.38 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(234,216)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C4.35 2 2.7 2 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(163,211)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C4.35 2 2.7 2 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(153,210)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 1.67 2.38 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(142,209)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0.495 2.97 0.495 6 1 C6 1.66 6 2.32 6 3 C3.03 2.505 3.03 2.505 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(112,204)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6.33 0.66 6.66 1.32 7 2 C4.69 1.67 2.38 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(102,203)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0.495 2.97 0.495 6 1 C6 1.66 6 2.32 6 3 C4.02 2.34 2.04 1.68 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(82,198)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-1.98 2.33 -3.96 2.66 -6 3 C-3.375 0 -3.375 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(91,160)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.98 0.66 -3.96 1.32 -6 2 C-6.33 1.34 -6.66 0.68 -7 0 C-3.86650268 -1.04449911 -3.01031744 -0.93423645 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(121,153)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C4 2 4 2 1.375 2.125 C0.59125 2.08375 -0.1925 2.0425 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(125,150)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C4 2 4 2 1.375 2.125 C0.59125 2.08375 -0.1925 2.0425 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(135,148)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.66 5 1.32 5 2 C3.02 2 1.04 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(146,146)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-1.98 2.33 -3.96 2.66 -6 3 C-6 2.34 -6 1.68 -6 1 C-3 0 -3 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(161,144)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.66 5 1.32 5 2 C3.02 2 1.04 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(207,138)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-1.98 2.33 -3.96 2.66 -6 3 C-6 2.34 -6 1.68 -6 1 C-3.92446352 0.4465236 -2.15634036 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(486,123)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-1.98 2.33 -3.96 2.66 -6 3 C-6 2.34 -6 1.68 -6 1 C-3.92446352 0.4465236 -2.15634036 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(496,121)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-1.98 2.33 -3.96 2.66 -6 3 C-6 2.34 -6 1.68 -6 1 C-3 0 -3 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(506,119)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-1.98 2.33 -3.96 2.66 -6 3 C-4.60722783 0.21445565 -3.01148006 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(516,116)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.495 2.475 0.495 5 1 C5 1.99 5 2.98 5 4 C3.31503702 3.03114628 1.64821244 2.03013277 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(557,52)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.4375 0.375 2.4375 0.375 5 1 C5.33 1.66 5.66 2.32 6 3 C3.03 2.505 3.03 2.505 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(548,48)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0.495 2.97 0.495 6 1 C6 1.66 6 2.32 6 3 C3.69 2.67 1.38 2.34 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(262,341)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C2.02 2 0.04 2 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(450,340)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.99 0 1.98 0 3 C-1.98 3.99 -1.98 3.99 -4 5 C-3 2 -3 2 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(551,309)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0.495 2.97 0.495 6 1 C6 1.66 6 2.32 6 3 C4.02 2.34 2.04 1.68 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(512,224)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 1.67 2.38 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(183,213)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-2.31 1.33 -4.62 1.66 -7 2 C-7 1.34 -7 0.68 -7 0 C-3.98968256 -0.93423645 -3.13349732 -1.04449911 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(223,138)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-2.31 2 -4.62 2 -7 2 C-4.35261084 0.5393715 -3.10551666 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(243,136)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0.66 3.96 1.32 6 2 C5.67 2.66 5.34 3.32 5 4 C2.525 3.01 2.525 3.01 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(538,44)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0.495 2.97 0.495 6 1 C6 1.33 6 1.66 6 2 C3.69 2 1.38 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(317,218)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C3.03 1.505 3.03 1.505 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(286,218)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C6.67 0.66 6.34 1.32 6 2 C3.03 1.505 3.03 1.505 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(214,215)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-2.31 1 -4.62 1 -7 1 C-3.375 -1.125 -3.375 -1.125 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(395,135)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0.33 4.62 0.66 7 1 C7 1.33 7 1.66 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(313,344)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C-0.31 2 -2.62 2 -5 2 C-5 1.67 -5 1.34 -5 1 C-2.625 0.375 -2.625 0.375 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(401,344)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C6.67 0.66 6.34 1.32 6 2 C3.03 1.505 3.03 1.505 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(292,344)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C2.68 2 1.36 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(212,337)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C6.34 0.66 5.68 1.32 5 2 C2.375 1.625 2.375 1.625 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(327,219)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.33 7 0.66 7 1 C5.02 1.33 3.04 1.66 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(367,136)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C2.68 2 1.36 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(257,136)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.495 2.475 0.495 5 1 C5 1.33 5 1.66 5 2 C3.35 2 1.7 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(520,40)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C5.67 0.66 5.34 1.32 5 2 C3.35 1.67 1.7 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(255,217)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.33 7 0.66 7 1 C4.69 1 2.38 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(275,137)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(337,137)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGtmCurveMobile);
export default __webpack_public_path__ + "static/media/gtm_curve_mobile.83cbd2cdca69e3c7653f9bba945b31ab.svg";
export { ForwardRef as ReactComponent };